import { render, staticRenderFns } from "./AllPriceItems.vue?vue&type=template&id=0ec9e916"
import script from "./AllPriceItems.vue?vue&type=script&lang=ts"
export * from "./AllPriceItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec9e916')) {
      api.createRecord('0ec9e916', component.options)
    } else {
      api.reload('0ec9e916', component.options)
    }
    module.hot.accept("./AllPriceItems.vue?vue&type=template&id=0ec9e916", function () {
      api.rerender('0ec9e916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AllPriceItems.vue"
export default component.exports